<template>
  <div :class="['notification-badge', { active }]">
    <FriedH5>{{ badgeLabel }}</FriedH5>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue';

export default defineComponent({
  props: {
    notificationCount: {
      type: Number,
      default: 0,
    },
    active: {
      type: Boolean,
    },
    maxCount: {
      type: Number,
      default: null,
    },
  },
  setup(props) {
    const badgeLabel = computed(() => {
      if (props.maxCount && props.notificationCount > props.maxCount) {
        return `${props.maxCount}+`;
      }
      return props.notificationCount;
    });

    return {
      badgeLabel,
    };
  },
});
</script>

<style lang="scss" scoped>
.notification-badge {
  height: 20px;
  width: auto;
  border-radius: var(--radius-large);
  padding: 0 var(--spacing-50);
  display: flex;
  justify-content: center;
  align-items: center;
  background: var(--blue-95);

  h5 {
    color: var(--blue-45);
  }

  &.active {
    background: var(--blue-45);

    h5 {
      color: var(--white);
    }
  }
}
</style>
